<div class="flex flex-col p-4 gap-4">
    @if(entry().translation) {
        <p class="text-primary -mt-4">{{ entry().translation }}</p>
    }

    @if(entry().tags) {
        <div class="flex flex-row gap-4">
            @for(tag of entry().tags; track $index) {
                <app-glossary-tag [text]="tag"></app-glossary-tag>
            }
        </div>
    }

    <p class="bg-background-dark rounded p-4 dark:border dark:border-grey">{{ entry().explanation }}</p>
</div>
